import { HttpContextToken } from '@angular/common/http';

export const SHOW_MODAL_ON_ERROR = new HttpContextToken<boolean>(() => false);

export type LoadingInterceptorToken = 'termine' | 'angebot' | 'anbieterfacette' | 'facetten' | null;

export const LOADING_INTERCEPTOR_TOKEN = new HttpContextToken<LoadingInterceptorToken>(() => null);
